module.exports = __webpack_public_path__ + "img/login-img.2d40012.png";